// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"675":"121d3394864483be1fb3","813":"ba1d81bbfe9624c0c5cf"}[chunkId] + ".css";
};